import { render, staticRenderFns } from "./ReportPushNotificationOpenings.vue?vue&type=template&id=f40032fc"
import script from "./ReportPushNotificationOpenings.vue?vue&type=script&lang=js"
export * from "./ReportPushNotificationOpenings.vue?vue&type=script&lang=js"
import style0 from "./ReportPushNotificationOpenings.vue?vue&type=style&index=0&id=f40032fc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports